import { set } from 'lodash/fp';
import createReducer from '../../../../../../helpers/createReducer';
import { createROPicklist } from '../../../../sagas/routines';

const initialState = {
  saving: false,
  saved: false
};

export const createROPicklistHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, saving: true, saved: false }),
  [routine.SUCCESS]: set('saved', true),
  [routine.FULFILL]: set('saving', false)
});

export default createReducer(initialState, {
  ...createROPicklistHandler(createROPicklist)
});
